import _createForOfIteratorHelper from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.number.constructor.js";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue"; // import Table from "@/views/annualCheck/components/Table.vue";

import { computed, defineComponent, onMounted, reactive, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import useCurrentInstance from "@/hooks/useCurrentInstance";
import { changeInfoTotal } from "@/hooks/changeInfoTotal";
export default defineComponent({
  name: "AnnualDetail",
  components: {
    Head: Head
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var Data = reactive({
      title: "",
      history: "",
      topData: {
        startTime: "2022-01-04 13:13:10",
        endTime: "2022-01-13 00:00:00",
        leftData: [{
          label: "姓名",
          english: "username",
          value: ""
        }, {
          label: "性别",
          english: "gender",
          value: ""
        }, {
          label: "出生日期",
          english: "birthday",
          value: ""
        }, {
          label: "民族",
          english: "nationName",
          value: ""
        }, {
          label: "手机号",
          english: "mobile",
          value: ""
        }, {
          label: "党内职务",
          english: "post",
          value: ""
        }, {
          label: "所在组织",
          english: "organizeName",
          value: ""
        }],
        rightData: [{
          label: "工号",
          english: "account",
          value: ""
        }, {
          label: "籍贯",
          english: "nativePlace",
          value: ""
        }, {
          label: "学历",
          english: "educationName",
          value: ""
        }, {
          label: "学位",
          english: "degreeName",
          value: ""
        }, {
          label: "入党时间",
          english: "partyDate",
          value: ""
        }, {
          label: "工作时间",
          english: "workingHours",
          value: ""
        }, {
          label: "转正时间",
          english: "correctionTime",
          value: ""
        }]
      },
      options: [],
      selfScore: 0,
      selfResult: [],
      secretaryScore: 0,
      secretaryResult: [],
      isAdmin: false,
      state: 0,
      allScore: 0,
      tips: [{
        title: "评议人未评分"
      }, {
        title: "自评未评议人评"
      }, {
        title: "自未平考核任凭"
      }, {
        title: "都评"
      }],
      auto: false,
      autoObj: {},
      totleScore: -1,
      isNone: true,
      isFinished: 0
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(route.query, "detail"); // Data.state = String(route.query.state);

              Data.isAdmin = String(route.query.admin) == "true";
              Data.title = String(route.query.title);
              Data.history = String(route.query.history);
              Data.topData.startTime = String(route.query.start);
              Data.topData.endTime = String(route.query.end);
              _context.next = 8;
              return getListDetail();

            case 8:
              _context.next = 10;
              return getSubmitState();

            case 10:
              if (!(Data.isAdmin == true)) {
                _context.next = 13;
                break;
              }

              _context.next = 13;
              return getUserDetail();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))); // 计算这个按钮是否应该显示

    var showBtn = computed(function () {
      // 自评人未自评
      if (String(route.query.state) == "0") {
        //
        return true;
      } // 自评人自评&&考核人未评分 自评人查看


      if (String(route.query.state) == "1" && Data.isAdmin == false) {
        //
        return false;
      } // 自评人自评&&考核人未评分 考核人查看


      if (String(route.query.state) == "1" && Data.isAdmin == true && Data.history == '0') {
        //
        return true;
      } // 考核人已评分并查看详情


      if (String(route.query.state) == "2") {
        //
        return false;
      } else {
        return false;
      }
    }); // 根据ID查询党员

    var getUserDetail = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, _iterator, _step, v, _iterator2, _step2, _v;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getEvaluationUser"]({
                  userId: Data.auto == false ? route.query.userId : Data.autoObj.userId
                });

              case 2:
                res = _context2.sent;
                // 顶部详情待考核人详情信息
                _iterator = _createForOfIteratorHelper(Data.topData.leftData);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    v = _step.value;

                    // 0 女 1 男
                    if (v.english == "gender") {
                      v.value = res.data[v.english] == 0 ? "女" : "男";
                    } else {
                      v.value = res.data[v.english];
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _iterator2 = _createForOfIteratorHelper(Data.topData.rightData);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    _v = _step2.value;
                    _v.value = res.data[_v.english];
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getUserDetail() {
        return _ref2.apply(this, arguments);
      };
    }(); // 获取考试试题详情


    var getListDetail = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, _iterator3, _step3, v;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getEvaluationRecords"]({
                  recordId: Data.auto == false ? route.query.recordId : Data.autoObj.recordId
                });

              case 2:
                res = _context3.sent;
                _iterator3 = _createForOfIteratorHelper(res.data.options);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    v = _step3.value;

                    if (!v.score) {
                      v.score = 0;
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                Data.state = String(res.data.processState);
                Data.isFinished = res.data.state;
                Data.options = res.data.options || [];
                Data.selfScore = res.data.selfScore || 0;
                Data.selfResult = res.data.selfResult || [];
                Data.secretaryScore = res.data.secretaryScore || 0;
                Data.secretaryResult = res.data.secretaryResult || [];
                Data.totleScore = res.data.totleScore || -1;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getListDetail() {
        return _ref3.apply(this, arguments);
      };
    }(); // 监听总分变化


    watch(function () {
      return Data.options;
    }, function (newVal) {
      var allScore = 0;

      var _iterator4 = _createForOfIteratorHelper(newVal),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var v = _step4.value;

          if (v.score) {
            allScore += v.score;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      Data.allScore = allScore;
    }, {
      deep: true
    }); // 判断状态

    var judgeState = computed(function () {
      if (Data.isAdmin == true) {
        if (String(route.query.state) == "0") {
          return "00";
        }

        if (String(route.query.state) == "1") {
          return "01";
        }

        if (String(route.query.state) == "2") {
          return "02";
        } else {
          return -1;
        }
      } else {
        if (String(route.query.state) == "0") {
          return "10";
        }

        if (String(route.query.state) == "1") {
          return "11";
        }

        if (String(route.query.state) == "2") {
          return "12";
        } else {
          return -1;
        }
      }
    }); // 如果是进行评分/考核

    var handleIsStarting = function handleIsStarting(res) {
      console.log("res: ", res); // 自评人未自评

      if (String(route.query.state) == "0") {
        console.log("1111111", res.data);

        var _iterator5 = _createForOfIteratorHelper(res.data.options),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var v = _step5.value;

            if (!v.score) {
              v.score = 0;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        Data.options = res.data.options;
      } // 自评人自评&&考核人未评分 自评人查看


      if (String(route.query.state) == "1" && Data.isAdmin == false) {
        console.log("2222222", res.data);

        var _iterator6 = _createForOfIteratorHelper(res.data.selfResult),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _v2 = _step6.value;

            if (!_v2.score) {
              _v2.score = 0;
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        Data.options = res.data.selfResult;
      } // 自评人自评&&考核人未评分 考核人查看


      if (String(route.query.state) == "1" && Data.isAdmin == true) {
        console.log("33333333", res.data);

        var _iterator7 = _createForOfIteratorHelper(res.data.options),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _v3 = _step7.value;

            if (!_v3.score) {
              _v3.score = 0;
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        Data.options = res.data.options;
      } // 考核人已评分并查看详情


      if (String(route.query.state) == "2") {
        console.log("4444444", res.data);

        for (var index in res.data.selfResult) {
          if (!res.data.selfResult[index].score) {
            res.data.selfResult[index].score = 0;
          }

          if (!res.data.secretaryResult[index].score) {
            res.data.secretaryResult[index].score = 0;
          }
        }

        Data.options = Data.isAdmin == true ? res.data.secretaryResult : res.data.selfResult;
        Data.secretaryResult = res.data.secretaryResult;
      }
    }; // 判断是否存在0分选项


    var decideCheck = function decideCheck() {
      //
      console.log(Data.options);
      var state = true;

      var _iterator8 = _createForOfIteratorHelper(Data.options),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var v = _step8.value;
          console.log(v.score);

          if (v.score == 0) {
            state = false;
            break;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return state;
    }; // 提交


    var handleSubmit = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var Decide, _iterator9, _step9, v, res;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return decideCheck();

              case 2:
                Decide = _context4.sent;

                if (!(Decide == false)) {
                  _context4.next = 6;
                  break;
                }

                ElMessage.error("\u5B58\u5728\u672A\u8BC4\u5206\u9879");
                return _context4.abrupt("return", false);

              case 6:
                _iterator9 = _createForOfIteratorHelper(Data.options);

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    v = _step9.value;
                    delete v.listId;
                    delete v.createTime;
                    delete v.createUser;
                    delete v.child;
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }

                _context4.next = 10;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getEvaluationSubmit"]({
                  recordId: Data.auto == false ? route.query.recordId : Data.autoObj.recordId,
                  submitDTOList: Data.options
                });

              case 10:
                res = _context4.sent;

                if (res.code == 0) {
                  ElMessage.success("\u63D0\u4EA4\u6210\u529F");
                  changeInfoTotal(Data.auto == false ? Number(route.query.recordId) : Number(Data.autoObj.recordId), "\u5E74\u5EA6\u8003\u6838\uFF1A".concat(Data.title), 23);
                  sessionStorage.setItem("keepActive", "true");
                  setTimeout(function () {
                    if (Data.isAdmin == true && res.data) {
                      handleAuto(res);
                    } else {
                      router.go(-1);
                    }
                  }, 500);
                } else {
                  ElMessage.success("".concat(res.msg));
                }

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function handleSubmit() {
        return _ref4.apply(this, arguments);
      };
    }(); // 自动跳转下一个人


    var handleAuto = function handleAuto(res) {
      Data.auto = true;
      Data.state = res.data.state;
      console.log("Data.state: ", Data.state);
      Data.isAdmin = true;
      Data.autoObj = res.data;
      getListDetail();
      getUserDetail();
    }; // 判断是否已经结束


    var getSubmitState = function getSubmitState() {// const state = dayjs(dayjs('2011-01-01')).isAfter(new Date())
      // console.log('是否已到期: ', state);
      // Data.isNone = state;
    };

    return {
      Data: Data,
      showBtn: showBtn,
      getListDetail: getListDetail,
      handleSubmit: handleSubmit,
      getUserDetail: getUserDetail,
      handleIsStarting: handleIsStarting,
      judgeState: judgeState,
      handleAuto: handleAuto,
      decideCheck: decideCheck,
      getSubmitState: getSubmitState
    };
  }
});